module.exports = __webpack_public_path__ + "static/media/checkMark.ba8a24d9.png";